import React from 'react'

import { string } from 'prop-types'

function EmptyState({
  title, description, linkText, linkHref,
}) {
  return (
    <div className="purchases-empty-state">
      <h3 className="purchases-empty-state__title cgt-legacy-heading-h3">{title}</h3>
      <p className="purchases-empty-state__description cgt-legacy-text-default">{description}</p>
      <a className="purchases-empty-state__link cgt-button cgt-button--primary" href={linkHref}>
        {linkText}
      </a>
    </div>
  )
}

EmptyState.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  linkText: string.isRequired,
  linkHref: string.isRequired,
}

export default EmptyState
